import type { TFunction } from 'i18next';
import { z } from 'zod';

// Schema for metadata field properties - matches JsonSchemaType from backend
const metadataFieldPropertySchema = z
  .object({
    type: z.enum(['string', 'number', 'boolean', 'date', 'section']),
    format: z.literal('date-time').optional(),
    description: z.string(),
    description_en: z.string().optional(),
    minLength: z.number().optional(),
    customerAccess: z.enum(['none', 'read', 'read-and-write']),
    groupId: z.string().optional(),
    width: z.enum(['33', '50', '100']).optional(),
  })
  .passthrough();

// Schema for metadata groups
const metadataGroupSchema = z
  .object({
    id: z.string(),
    labelDe: z.string(),
    labelEn: z.string().optional(),
    order: z.number(),
  })
  .passthrough();

// Full JsonSchemaType schema
const jsonSchemaTypeSchema = z
  .object({
    type: z.literal('object'),
    groups: z.array(metadataGroupSchema).optional(),
    properties: z.record(z.string(), metadataFieldPropertySchema),
    required: z.array(z.string()),
    propertyOrder: z.array(z.string()),
  })
  .passthrough();

export const createContractSchema = (
  t: TFunction<'compat'>,
  metadataSchema: z.ZodObject<z.ZodRawShape>,
  dynamicMetadataSchema: z.ZodObject<z.ZodRawShape>
) =>
  z.object({
    contractNumber: z.string().optional(),
    title: z.string().min(1, t('validation.required')),
    customer: z.string().min(1, t('validation.required')),
    objects: z.array(z.string()).optional(),
    startDate: z.string().min(1, t('validation.required')),
    endDate: z.string().min(1, t('validation.required')),
    description: z.string().optional(),
    status: z.enum(['open', 'closed']).optional(),
    metadata: metadataSchema,
    dynamicMetadataSchema: jsonSchemaTypeSchema.optional(),
    dynamicMetadataValues: dynamicMetadataSchema,
  });
